var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback } from 'react';
import cx from 'classnames';
import { Avatar as WAXAvatar } from '@noom/wax-component-library';
import customizableComponent from '../../../core/hocs/customization';
import withSize from '../../../core/hocs/withSize';
import { backgroundImage as UserImage } from '../../../icons/User';
import { SIZE_TO_WAX } from '../../../core/hocs/withSize';
import { CommunityNoom } from '../../../icons';
import { AvatarContainer, AvatarOverlay } from './styles';
const Avatar = (_a) => {
    var { className, avatar = null, showOverlay, size, onClick, loading, displayName, backgroundImage, isCommunity, isLazy } = _a, props = __rest(_a, ["className", "avatar", "showOverlay", "size", "onClick", "loading", "displayName", "backgroundImage", "isCommunity", "isLazy"]);
    const communityProps = isCommunity ? { icon: React.createElement(CommunityNoom, { p: 1, color: "white" }) } : {};
    return (React.createElement(AvatarContainer, Object.assign({ className: cx(className, { clickable: !!onClick }), loading: loading, size: size, onClick: onClick }, props), avatar && showOverlay ? (React.createElement(AvatarOverlay, Object.assign({}, props),
        React.createElement(WAXAvatar, Object.assign({}, communityProps, { size: SIZE_TO_WAX[size], src: avatar || backgroundImage, name: displayName, h: "100%", w: "100%", loading: isLazy ? 'lazy' : 'eager' })))) : (React.createElement(WAXAvatar, Object.assign({}, communityProps, { size: SIZE_TO_WAX[size], src: avatar || backgroundImage, name: displayName, h: "100%", w: "100%", loading: isLazy ? 'lazy' : 'eager' })))));
};
Avatar.defaultProps = {
    backgroundImage: UserImage,
    loading: false,
    isCommunity: false,
};
export default customizableComponent('Avatar', withSize(Avatar));
//# sourceMappingURL=index.js.map